import React from "react"
import { Link } from "react-router-dom"
import { Header, Card, Image } from "semantic-ui-react"

const CategoryCard = ( { category } ) => <Card as={Link} to={`/bildwelt/${category.slug}`}>
  <Image src={category.img}/>
  <Card.Content>
    <Header>{category.name}</Header>
    {/*<pre>{JSON.stringify(image, null, 2)}</pre>*/}
  </Card.Content>
</Card>

export default CategoryCard


// WEBPACK FOOTER //
// ./src/components/ShoppableImage/CategoryCard.js